import { FamilyNewsletterOptionsEnum } from "@/consts/newsletter";
import { disableFamilyNewsletterOption } from "@/utils/disableFamilyNewsletterOption";

  export const setFamilyEngagementCategory = (facility: any, value: boolean) => {
      facility.featureFamilyEngagement = value;
      facility.familyChatEnabled = value;
      facility.scheduledCallsEnabled = value;
      facility.residentCanTakePhoto = value;
      facility.canStaffMessageFamily = value;
      facility.isResidentChat = value;
      facility.isEnableFamilyNewsletter = value;
        if (!value) {
          disableFamilyNewsletterOption(facility, FamilyNewsletterOptionsEnum.VideoCalls);
        }
      facility.isStaffCanLogInOnBehalfOfResident = value;
      facility.residentConsentCheckbox = value;
      facility.isStaffHubContentManagerGallery = value;
      facility.isStaffHubSurveys = value;
      facility.mediaEnabled = value;
      facility.isStaffHubContentManagerMediaLibrary = value;
      facility.isStaffHubDocuments = value;
      facility.isEnabledDocumentsTile = value;
      facility.isEnabledMyHubFamilyTile = value;
      facility.isEnabledFamilyToResidentMessaging = value;
      facility.isUsingIntercom = value;

      if(!value) {
        facility.isEnabledStaffDirectory = value;
        facility.isEnabledKioskButton = value;
        facility.canInviteFamilyMembers = value;
        facility.isEnableResidentsCanInviteFamily = value;
      }
    }